(function () {
  if (window.__howInitialized) return;
  window.__howInitialized = true;

  var initializedSections = new WeakSet();

  function initSection(root) {
    if (!root || initializedSections.has(root)) return;
    initializedSections.add(root);

    var steps = root.querySelectorAll('[data-how-reveal]');
    var line = root.querySelector('[data-how-line]');
    var track = root.querySelector('.how__track');
    if (!steps.length) return;

    steps.forEach(function (el, i) {
      el.style.setProperty('--stagger', (i * 90) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      steps.forEach(function (el) { el.classList.add('is-visible'); });
      if (line) line.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    steps.forEach(function (el) { observer.observe(el); });

    if (line && track) {
      var lineObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            line.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
      );
      lineObserver.observe(track);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-how]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-how]');
    if (root) {
      initializedSections.delete(root);
      root.querySelectorAll('[data-how-reveal]').forEach(function (el) {
        el.classList.remove('is-visible');
      });
      var line = root.querySelector('[data-how-line]');
      if (line) line.classList.remove('is-visible');
      initSection(root);
    }
  });
})();